// let tabs = Array.from(document.querySelectorAll('.education-tabs'))
// let buttonPresta = document.getElementById('ref-presta')
// let buttonWp = document.getElementById('ref-wordpress')


// buttonWp?.addEventListener('click', function(){

//     let tabsFormation = document.querySelectorAll('.education-tabs > .tabs-btn')
//     let data = buttonWp.dataset.class
//     let sections = document.querySelectorAll('.education-section')
//     let selectedSection = document.querySelector(`.${data}`)

//     tabsFormation.forEach(tab => tab.classList.remove('active'))

//     tabsFormation.forEach(tab => {
//         if(tab.dataset.class == data){
//             tab.classList.add('active')
//         }
//     })

//     sections.forEach(section => section.classList.remove('active'))
//     selectedSection.classList.add('active')
// })

// buttonPresta?.addEventListener('click', function(){

//     let tabsPresta = document.querySelectorAll('.education-tabs > .tabs-btn')
//     let data = buttonPresta.dataset.class
//     let sections = document.querySelectorAll('.education-section')
//     let selectedSection = document.querySelector(`.${data}`)

//     tabsPresta?.forEach(tab => tab.classList.remove('active'))

//     tabsPresta?.forEach(tab => {
//         if(tab.dataset.class == data){
//             tab.classList.add('active')
//         }
//     })

//     sections?.forEach(section => section.classList.remove('active'))
//     selectedSection.classList.add('active')
// })

// tabs?.forEach((tab) => {
//     let tabItems = tab.querySelectorAll('.tabs-btn')
//     let section = document.querySelector('.section-cms');
//     // let element = tab.closest('.fl-node-ojetz9740xbp');
//     let element = tab.closest('.fl-node-flhmdab57x6v');
  
//     window.addEventListener('scroll', function() {
//         //check if the top of the section arrives at the top of the viewport and add class, but when the bottom of the section arrives at the top of the viewport remove the class
//         if (section.getBoundingClientRect().top <= 0 && section.getBoundingClientRect().bottom >= 0) {
//             element.classList.add('is-sticky');
//         } else {
//             element.classList.remove('is-sticky');
//         }
//     })

//     tabItems.forEach((tabItem) => {
//         tabItem.addEventListener('click', e => {
//             e.preventDefault()

//             //scroll to the top of the section
//             section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
//             tabItems.forEach(item => item.classList.remove('active'))
//             tabItem.classList.add('active')

//             let sections = document.querySelectorAll('.education-section')
//             let data = tabItem.dataset.class
//             let selectedSection = document.querySelector(`.${data}`)
            
//             sections.forEach(section => section.classList.remove('active'))
//             selectedSection.classList.add('active')
//         })
//     })

//     window.addEventListener('load', function() {

//         tabItems?.forEach(item => item.classList.remove('active'))
//         tabItems[0].classList.add('active')
  
//         let sections = document.querySelectorAll('.education-section')
//         let data = tabItems[0].dataset.class
//         let selectedSection = document.querySelector(`.${data}`)
        
//         sections.forEach(section => section.classList.remove('active'))
//         selectedSection.classList.add('active')
//     })
// })

// let tabsSeo = Array.from(document.querySelectorAll('.seo-tabs'))

// tabsSeo?.forEach((tab) => {
//     let tabItems = tab.querySelectorAll('.tabs-btn')
//     let section = document.querySelector('.section-seo');
//     // let element = tab.closest('.fl-node-kvirebta8mlh');
//     let element = tab.closest('.fl-node-iym3varlen1c');
  
//     window.addEventListener('scroll', function() {
//         if (section.getBoundingClientRect().top <= 0 && section.getBoundingClientRect().bottom >= 0) {
//             element.classList.add('is-sticky');
//         } else {
//             element.classList.remove('is-sticky');
//         }
//     })

//     tabItems?.forEach((tabItem) => {
//         tabItem?.addEventListener('click', e => {
//             e.preventDefault()

//             section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
//             tabItems.forEach(item => item.classList.remove('active'))
//             tabItem.classList.add('active')

//             let sections = document.querySelectorAll('.seo-section')
//             let data = tabItem.dataset.class
//             let selectedSection = document.querySelector(`.${data}`)
            
//             sections.forEach(section => section.classList.remove('active'))
//             selectedSection.classList.add('active')
//         })
//     })

//     window.addEventListener('load', function() {

//       tabItems.forEach(item => item.classList.remove('active'))
//       tabItems[0].classList.add('active')

//       let sections = document.querySelectorAll('.seo-section')
//       let data = tabItems[0].dataset.class
//       let selectedSection = document.querySelector(`.${data}`)
      
//       sections.forEach(section => section.classList.remove('active'))
//       selectedSection.classList.add('active')
//     })
// })

// let tabsEcommerce = Array.from(document.querySelectorAll('.ecommerce-tabs'))

// tabsEcommerce?.forEach((tab) => {
//     let tabItems = tab.querySelectorAll('.tabs-btn')
//     let section = document.querySelector('.section-ecommerce');
//     // let element = tab.closest('.fl-node-q1umsdpk0xgn');
//     let element = tab.closest('.fl-node-kl9dgyxiq4zh');

//     window.addEventListener('scroll', function() {
//       if (section.getBoundingClientRect().top <= 0 && section.getBoundingClientRect().bottom >= 0) {
//           element.classList.add('is-sticky');
//       } else {
//           element.classList.remove('is-sticky');
//       }
//     })

//     tabItems?.forEach((tabItem) => {
//         tabItem.addEventListener('click', e => {
//             e.preventDefault()

//             section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
//             tabItems.forEach(item => item.classList.remove('active'))
//             tabItem.classList.add('active')

//             let sections = document.querySelectorAll('.ecommerce-section')
//             let data = tabItem.dataset.class
//             let selectedSection = document.querySelector(`.${data}`)
            
//             sections.forEach(section => section.classList.remove('active'))
//             selectedSection.classList.add('active')
//         })
//     })

//     window.addEventListener('load', function() {

//       tabItems?.forEach(item => item.classList.remove('active'))
//       tabItems[0].classList.add('active')

//       let sections = document.querySelectorAll('.seo-ecommerce')
//       let data = tabItems[0].dataset.class
//       let selectedSection = document.querySelector(`.${data}`)
      
//       sections?.forEach(section => section.classList.remove('active'))
//       selectedSection.classList.add('active')
//     })
// })

